"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TtsModelFamily = void 0;
exports.TtsModelFamily = {
    Turbo: "turbo",
    Flash: "flash",
    Multilingual: "multilingual",
};
